import { template } from "@ember/template-compiler";
import styles from '@hokulea/core/forms.module.css';
import type { TOC } from '@ember/component/template-only';
export interface DescriptionSignature {
    Element: HTMLParagraphElement;
    Blocks: {
        default: [];
    };
}
const Description: TOC<DescriptionSignature> = template(`
  <p class={{styles.description}} data-test-description ...attributes>
    {{yield}}
  </p>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default Description;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2hva3VsZWEvaG9rdWxlYS9lbWJlci9wYWNrYWdlL3NyYy8tcHJpdmF0ZS9mb3JtL2NvbXBvbmVudHMvZGVzY3JpcHRpb24uZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZXMgZnJvbSAnQGhva3VsZWEvY29yZS9mb3Jtcy5tb2R1bGUuY3NzJztcblxuaW1wb3J0IHR5cGUgeyBUT0MgfSBmcm9tICdAZW1iZXIvY29tcG9uZW50L3RlbXBsYXRlLW9ubHknO1xuXG5leHBvcnQgaW50ZXJmYWNlIERlc2NyaXB0aW9uU2lnbmF0dXJlIHtcbiAgRWxlbWVudDogSFRNTFBhcmFncmFwaEVsZW1lbnQ7XG4gIEJsb2Nrczoge1xuICAgIGRlZmF1bHQ6IFtdO1xuICB9O1xufVxuXG5jb25zdCBEZXNjcmlwdGlvbjogVE9DPERlc2NyaXB0aW9uU2lnbmF0dXJlPiA9IDx0ZW1wbGF0ZT5cbiAgPHAgY2xhc3M9e3tzdHlsZXMuZGVzY3JpcHRpb259fSBkYXRhLXRlc3QtZGVzY3JpcHRpb24gLi4uYXR0cmlidXRlcz5cbiAgICB7e3lpZWxkfX1cbiAgPC9wPlxuPC90ZW1wbGF0ZT47XG5cbmV4cG9ydCBkZWZhdWx0IERlc2NyaXB0aW9uO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLFlBQVksaUNBQWlDO0FBRXBELGNBQWMsR0FBRyxRQUFRLGlDQUFpQztBQUUxRCxpQkFBaUI7SUFDZixTQUFTO0lBQ1Q7UUFDRTs7O0FBSUosTUFBTSxhQUFhLElBQUksd0JBQXdCLFNBQVUsQ0FBQTs7OztBQUl6RCxDQUFBLEVBQUE7SUFBQTtRQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUE7QUFFVixlQUFlLFlBQVkifQ